import type { WeekDays } from './common.types';
import type { GlassWasherModel } from './glass-washers.types';
import type { PythonModel } from './pythons.types';
import type { TapModel } from './taps.types';
import type { UserModel } from './users.types';
import type { VenueModel } from './venues.types';

export enum BarStatusType {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
  ARCHIVED = 'Archived'
}

export enum BarType {
  PUB = 'Pub',
  BAR = 'Bar',
  BISTRO_GASTRO = 'Bistro/Gastro',
  RESTAURANT = 'Restaurant',
  CLUB = 'Club',
  OCCASIONAL_FUNCTION = 'Occasional/Function',
  EVENT_VENUE = 'Event/Venue',
  POPUP = 'Popup',
  OUTDOOR = 'Outdoor',
  UNDER_COUNTER = 'Under Counter'
}

export interface BarModel {
  id: string;
  name: string;
  barType: BarType | null;
  statusType: BarStatusType | null;
  pythons: PythonModel[];
  defaultPythonId: string | null;
  openingHour: string | null;
  closingHour: string | null;
  closedDay: WeekDays | null;
  accessDuringLicense: boolean;
  description: string | null;
  accessDays: WeekDays[] | null;
  accessWindowOpen: string | null;
  accessWindowClose: string | null;
  productDeliveryDays: WeekDays[] | null;
  contacts: UserModel[];
  taps: TapModel[];
  glassWashers: GlassWasherModel[];
  venue: VenueModel;
  createdAt?: string;
  updatedAt?: string;
}

export interface ListBarsResponse {
  result: ListBarModel[];
  limit: number;
  offset: number;
  count: number;
}

export interface ListAllBarsResponse {
  allBarsResult: ListBarModel[];
}

export interface CreateBarParams {
  name: string;
  venueId: string;
  contacts: string[];
  barType?: BarType | null;
  statusType?: BarStatusType | null;
  openingHour?: string | null;
  closingHour?: string | null;
  closedDay?: WeekDays | null;
  accessDuringLicense?: boolean | null;
  description?: string | null;
  accessDays?: string[] | null;
  accessWindowOpen?: string | null;
  accessWindowClose?: string | null;
  productDeliveryDays?: string[] | null;
}

export interface DisabledBarVenueFieldsProps {
  accessWindowOpen: boolean;
  accessWindowClose: boolean;
  accessDays: boolean;
  productDeliveryDays: boolean;
}

export interface UpdateBarParams extends CreateBarParams {
  defaultPythonId?: string | null;
}

export interface UpdateBarParamsWithId extends UpdateBarParams {
  barId: string;
}

export interface DeleteBarParams {
  barId: string;
}

export interface BarFiltersProps {
  clientName?: string;
  venueId?: string;
  venueName?: string;
  barType?: BarType;
  statusType?: BarStatusType;
}

export type ListBarModel = Pick<BarModel, 'id' | 'name' | 'barType' | 'statusType'> & {
  tapsCount: number;
};

export type BarsSortingFields = 'name' | 'barType' | 'statusType' | 'tapsCount';
